import React from 'react'
import IMG6 from "../Images/JavaScript-logo.png"
function JsLogo() {
  return (
    <>
<img src={IMG6} style={{width:"200px",height:"150px"}} alt='js'/>
    </>
  )
}

export default JsLogo